import styled from "styled-components";

export const HomeContainer = styled.section`
  height: 100%;
`;